import { compareDesc } from 'date-fns';
import * as yup from 'yup';

const address = yup
  .object()
  .when('mode', {
    is: 'O',
    then: (schema) =>
      schema.shape({
        city: yup.string().required('Укажите город'),
        street: yup.string().required('Укажите улицу'),
        house: yup.string(),
      }),
  })
  .nullable();

// const coach = yup.object().shape({
//   first_name: yup.string().required('Укажите имя ведущего'),
//   last_name: yup.string().required('Укажите фамилию ведущего'),
//   description: yup.string().required('Заполните описание'),
// });

// const coachArray = yup.array().of(coach);

const cost = yup
  .number()
  .required('Укажите стоимость мероприятия')
  .typeError('Укажите стоимость мероприятия');

const cost_payment_method = yup.string().required('').nullable();

// const costs = yup.array().of(
//   yup.object().shape({
//     cost: yup.number().required(' '),
//     group: yup.mixed().required(' '),
//     payment_method: yup.string().required(''),
//   })
// );

const date = yup.object().shape({
  time_from_day: yup.date().required('Укажите время начала').typeError('Укажите время начала'),
  time_from: yup.date().required('Укажите время начала').typeError('Укажите время начала'),
  time_to: yup
    .date()
    .required('Укажите время окончания')
    .typeError('Укажите время окончания')
    .min(yup.ref('time_from'), 'Окончание раньше начала'),
});

// const description = yup.string().required('Опишите мероприятие');

const event_type = yup.string().required('Укажите тип мероприятия');

const external_service = yup.string().required('Вставьте ссылку').nullable();

const language = yup.string().required('Укажите язык мероприятия');

const mode = yup.string().required('Укажите режим мероприятия');

const title = yup.string().required('Укажите название мероприятия');

const timetable = yup
  .array()
  .of(date)
  .test({
    name: 'validate day start',
    test: (value, ctx) => {
      const dateNow = new Date();
      if (value && value.length > 1) {
        const days = [...value];
        for (let i = 0; i < days.length; i++) {
          if (i > 0 && days[i].time_from && days[i - 1].time_to) {
            const startTime = days[i].time_from!;
            const prevEndTime = days[i - 1].time_to!;

            if (dateNow < startTime) {
              return false;
            }

            if (compareDesc(startTime, prevEndTime) !== -1) {
              return ctx.createError({
                message: `Время этапов не может пересекаться`,
                path: `timetable[${i}].time_from_day`, // Fieldname
              });
            }
          }
        }
      }

      if (value && value.length > 0 && value[0].time_from < dateNow) {
        return ctx.createError({
          message: `Мероприятие не может быть в прошедшем времени`,
          path: `timetable[0].time_from_day`,
        });
      }

      return true; // Если все проверки прошли
    },
  });

// const places = yup
//   .number()
//   .required('Укажите количество участников')
//   .min(1, 'Слишком мало участников');

// const contacts = yup.array().min(1, 'Нужно указать контакт для связи');

const prepaymentCost = yup
  .number()
  .test('is-less-than-cost', 'Предоплата больше указанной стоимости', function (value) {
    const { cost } = this.parent;
    if (cost === 0 || !value) {
      return true;
    }
    if (value) {
      return value < cost;
    }
  })
  .test('is-less-than-cost', 'Предоплата не может быть равна нулю', function (value) {
    const { cost, cost_payment_method } = this.parent;
    if (cost_payment_method === 'O') {
      return true;
    }
    if (value && cost > 0) {
      return value > 0;
    }
    return true;
  });

const eventImage = yup.string().min(1).required('Загрузите обложку');

const schema = yup.object().shape({
  title: title,
  event_image: eventImage,
  // description: description,
  address: address,
  cost: cost,
  cost_payment_method: cost_payment_method,
  // costs: costs,
  // event_coach: coachArray,
  event_type: event_type,
  external_service: external_service,
  prepayment_cost: prepaymentCost,
  language: language,
  mode: mode,
  // places: places,
  timetable: timetable,
  // contacts: contacts,
});

export default schema;
